<template>
    <el-container direction="vertical" class="debts">
        <el-row class="header">
            <el-col>
                <div class="title">
                    {{ title }}
                </div>
            </el-col>
        </el-row>
        <el-row class="main" v-loading="loading">
            <el-col>
                <div v-if="debts.length">
                    <h3>Задолженность сотрудников перед компанией: {{ formatFinance(totalDebtsAmount) }} руб.</h3>
                </div>
                <div v-for="position in debts" :key="position.id">
                    <div class="row" @click="handlePositionClick(position)">
                        <div class="name">
                            <i class="el-icon-caret-bottom" v-if="position.isOpened"></i>
                            <i class="el-icon-caret-right" v-else></i>
                            {{ position.name }}:
                        </div>
                        <div class="amount pl15">
                            {{ formatFinance(position.debtsTotal) }} руб.
                        </div>
                    </div>
                    <template v-if="position.employers.length && position.isOpened">
                        <div v-for="employer in position.employers" :key="employer.id">
                            <div class="row" @click="handleEmployerClick(employer)">
                                <div class="name pl15">
                                    <i class="el-icon-caret-bottom" v-if="employer.isGridShown"></i>
                                    <i class="el-icon-caret-right" v-else></i>
                                    {{ employer.name }}:
                                </div>
                                <div class="amount">
                                    {{ formatFinance(employer.debtsTotal, 0) }} руб.
                                    <template v-if="employer.installersDebt">
                                        (должен забрать деньги у клиента {{ formatFinance(employer.installersDebt, 0) }} руб.)
                                    </template>
                                </div>
                            </div>
                            <div class="grid-wrapper">
                                <employer-deals-debts
                                    :id="employer.id"
                                    :name="employer.name"
                                    v-if="employer.isGridShown"
                                />
                                <installer-deals-debts
                                    :id="employer.id"
                                    :name="employer.name"
                                    v-if="employer.isGridShown && position.id === localReferences.employerPositions.installer"
                                />
                            </div>
                        </div>
                    </template>
                </div>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import '@/assets/styles/debts.scss';
import EmployerDealsDebts from '@/components/debts/EmployerDealsDebts';
import InstallerDealsDebts from '@/components/debts/InstallerDealsDebts';
import localReferences from '@/helpers/localReferences';

export default {
    name: 'DebtsEmployers',
    data() {
        return {
            localReferences,
            title: 'Долги Сотрудники',
            loading: false,
            debts: [],
            totalDebtsAmount: null
        };
    },
    components: {
        EmployerDealsDebts,
        InstallerDealsDebts
    },
    mounted() {
        this.getDebts();
    },
    methods: {
        handlePositionClick(position) {
            if (position.isOpened === false) {
                const opened = this.debts.find(position => position.isOpened);
                if (opened) {
                    opened.isOpened = false;
                }
            }
            position.isOpened = !position.isOpened;
        },
        handleEmployerClick(employer) {
            if (employer.isGridShown === false) {
                this.debts.forEach(position => {
                    const alreadyShownGridCell = position.employers.find(employer => employer.isGridShown);
                    if (alreadyShownGridCell) {
                        alreadyShownGridCell.isGridShown = false;
                    }
                });
            }
            employer.isGridShown = !employer.isGridShown;
        },
        formatFinance(num) {
            return num ? num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ') : 0;
        },
        async getDebts() {
            this.loading = true;
            try {
                const response = await this.$store.dispatch('debts/getEmployersDebts');
                this.debts = response.map(position => {
                    return {
                        id: position.id,
                        name: position.name,
                        isOpened: false,
                        debtsTotal: position.employers.filter(employer => employer.debtsTotal !== 0).reduce((total, employer) => total + employer.debtsTotal, 0),
                        employers: position.employers.filter(employer => employer.debtsTotal !== 0).map(employer => {
                            return {
                                id: employer.id,
                                name: employer.name,
                                debtsTotal: employer.debtsTotal,
                                installersDebt: employer.installersDebt,
                                isGridShown: false
                            };
                        })
                    };
                }).filter(position => position.debtsTotal !== 0);
                this.totalDebtsAmount = this.debts.reduce((total, position) => total + position.debtsTotal, 0);
            } catch (error) {
                console.log(error.message);
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>
